import "../scss/styles.scss";

import onChange from 'on-change';
import calc from './calc';
import {render} from './render';

import {webflowRestart} from "./utils";
import {tabsModalStart} from "./function";
import htmlTemplateForm from "./htmlTemplateForm";

// controller

// watch switcher changes
const updateExclude = (form, watchedState) => {
  const excludesElements = form.querySelectorAll('.switcher');
  const { exclude } = watchedState.form;

  for (let i = 0; i < excludesElements.length; i++) {
    excludesElements[i].addEventListener('change', function() {
      let siblingInput = excludesElements[i].parentNode.parentNode.parentNode.querySelector('.input');
      siblingInput.value = '';

      if (excludesElements[i].value === '$') {
        if(siblingInput.name === 'annual-tax'){
          siblingInput.step = '1000';
          siblingInput.placeholder = '1000';
        }
        if(siblingInput.name === 'annual-insurance'){
          siblingInput.step = '100';
          siblingInput.placeholder = '100';
        }
        if(siblingInput.name === 'annual-pmi'){
          siblingInput.step = '100';
          siblingInput.placeholder = '100';
        }
      } else {
        if(siblingInput.name === 'annual-tax'){
          siblingInput.step = '0.1';
          siblingInput.placeholder = '0.1';
        }
        if(siblingInput.name === 'annual-insurance'){
          siblingInput.step = '0.1';
          siblingInput.placeholder = '0.1';
        }
        if(siblingInput.name === 'annual-pmi'){
          siblingInput.step = '0.1';
          siblingInput.placeholder = '0.1';
        }      }
    });
  }

  [...excludesElements].forEach((excludeItem) => {
    switch (excludeItem.checked) {
      case true:
        exclude[excludeItem.name] = excludeItem.value;
        break;
      case false:
        break;
      default:
        break;
    }
  });
};

const updateValues = (elements, watchedState) => {
  const { values } = watchedState.form;
  const { form } = elements;
  const formData = new FormData(form);

  // update values
  [...formData.entries()].forEach(([key, value]) => {
    if (key in values) {
      values[key] = value === '' ? 0 : +value;
    }
  });

  // update exclude list
  updateExclude(form, watchedState);
};

const updateUserValues = (elements, watchedState) => {
  const { user } = watchedState.form;
  const { form } = elements;
  const formData = new FormData(form);

  // update values
  [...formData.entries()].forEach(([key, value]) => {
    if (key in user) {
      user[key] = value;
      // console.log(values[key])
    }
  });

  // update exclude list
  updateExclude(form, watchedState);
};

const init = () => {

  const isTemplate = htmlTemplateForm();
  tabsModalStart();
  if(!isTemplate) {
    return false;
  }

  // MODEL
  const elements = {
    form: document.forms.calcHowMuch,
    formRerender: document.getElementById('rerender'),
    modalSending: document.getElementById('modalSendResult'),
    // results detail
    resultMonthlyPI: document.querySelectorAll('[data-calc-result="monthly-pi"]'),
    resultMonthlyRealTaxes: document.querySelectorAll('[data-calc-result="monthly-real-taxes"]'),
    resultMonthlyInsurance: document.querySelectorAll('[data-calc-result="monthly-insurance"]'),
    resultLoanValRatio: document.querySelectorAll('[data-calc-result="loan-value-ratio"]'),
    resultMonthWithPMI: document.querySelectorAll('[data-calc-result="month-with-pmi"]'),
    resultMonthlyPMI: document.querySelectorAll('[data-calc-result="monthly-pmi"]'),

    // results detail in text
    resultAmount: document.querySelector('[data-calc-result="amount"]'),
    resultAmountNoPennies: document.querySelector('[data-calc-result="amount-no-pennies"]'),
    resultLengthYears: document.querySelector('[data-calc-result="length-years"]'),
    resultInterestRate: document.querySelector('[data-calc-result="interest-rate"]'),
    resultHomeValue: document.querySelector('[data-calc-result="home-value"]'),
    resultHomeValueNoPennies: document.querySelector('[data-calc-result="home-value-no-pennies"]'),
    resultAnnualTaxes: document.querySelector('[data-calc-result="annual-taxes"]'),
    resultAnnualInsurance: document.querySelector('[data-calc-result="annual-insurance"]'),

    // total result
    resultMonthlyPayment: document.querySelectorAll('[data-calc-result="monthly-payment"]'),

    // switchers
    switchTaxes: document.querySelectorAll('[data-switch="switch-taxes"]'),
    switchInsurance: document.querySelectorAll('[data-switch="switch-insurance"]'),
    switchPmi: document.querySelectorAll('[data-switch="switch-pmi"]'),

    // pmi show if result
    showPmi: document.querySelectorAll('[data-exclude="no-pmi"]'),

    // sending status
    success: document.querySelector('.form-send__status-ok'),
    error: document.querySelector('.form-send__status-fail'),
  };
  // MODEL
  const state = {
    form: {
      user: {
        'name': '',
        'email': '',
        'phone': '',
      },
      values: {
        // input values
        'amount': 0,
        'interest-rate': 0,
        'length-years': 0,
        'home-value': 0,
        'annual-tax': 0,
        'annual-insurance': 0,
        'annual-pmi': 0,
      },
      exclude: {
        'switch-taxes': '$',
        'switch-insurance': '$',
        'switch-pmi': '%',
      },
    },
    result: {
      // results
      'monthly-pi': null,
      'monthly-real-taxes': null,
      'monthly-insurance': null,
      'loan-value-ratio': null,
      'month-with-pmi': null,
      'monthly-pmi': null,
      // res details in text
      'amount': null,
      'interest-rate': null,
      'length-years': null,
      'home-value': null,
      'annual-tax': null,
      'annual-insurance': null,
      'annual-pmi': null,
      // total
      'monthly-payment': null,
    },
  };

  // MODEL
  const watchedState = onChange(state, () => {
    calc(elements, watchedState);
  });

  // CONTROLLER
  const { form, formRerender, modalSending } = elements;
  const { result } = watchedState;
  const { values, exclude, user } = watchedState.form;

  formRerender.addEventListener('click', (e) => {
    e.preventDefault();
    render(elements, watchedState);
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    updateValues(elements, watchedState);
    updateUserValues(elements, watchedState);

    let submitter = e.submitter,
        submitCurrentText = submitter.innerHTML,
        submitWaitText = submitter.dataset.wait,
        submitErrorText = submitter.dataset.error,
        submitSuccessText = submitter.dataset.success;

    let formData = {
      // form id
      "form_id": elements.form.id,
      // user data
      "name": user["name"],
      "email": user["email"],
      "phone": user["phone"],
      // input data
      "amount": values["amount"],
      "interest_rate": values["interest-rate"],
      "length_years": values["length-years"],
      "home_value": values["home-value"],
      "annual_tax": values["annual-tax"],
      "annual_insurance": values["annual-insurance"],
      "annual_pmi": values["annual-pmi"],
      // results
      "monthly_pi": result["monthly-pi"],
      "monthly_real_taxes": result["monthly-real-taxes"],
      "monthly_insurance": result["monthly-insurance"],
      "loan_value_ratio": result["loan-value-ratio"],
      "month_with_pmi": result["month-with-pmi"],
      "monthly_pmi": result["monthly-pmi"],
      // switches
      'switch_taxes': exclude["switch-taxes"],
      'switch_insurance': exclude["switch-insurance"],
      'switch_pmi': exclude["switch-pmi"],
      // details result in text
      "amount_details": result["amount"],
      "interest_rate_details": result["interest-rate"],
      "length_years_details": result["length-years"],
      "annual_tax_details": result["annual-tax"],
      "annual_insurance_details": result["annual-insurance"],
      "annual_pmi_details": result["annual-pmi"],
      // total
      "monthly_payment": result["monthly-payment"],
    };
    // ***
    if(user["email"] !== ''){
      submitter.innerHTML = submitWaitText;
      fetch("https://digitalbutlers.me/any_scripts/ligolab/sheets/test/send_results.php", {
        method: "POST",
        body: JSON.stringify(formData),
        // body: formData,
      }).then(function (response) {
        if (response.status === 200){
          submitter.innerHTML = submitSuccessText;
          setTimeout(function () {
            modalSending.classList.remove('open');
            document.body.classList.remove("no-scroll");
            submitter.innerHTML = submitCurrentText;
            form.reset();
          }, 1000)
        } else {
          submitter.innerHTML = submitErrorText;
          setTimeout(function () {
            modalSending.classList.remove('open');
            document.body.classList.remove("no-scroll");
            form.reset();
            submitter.innerHTML = submitCurrentText;
          }, 1000)
        }
      }).catch(function (error) {
        submitter.innerHTML = submitErrorText;
        console.log(error);
      });
    } else {
      submitter.innerHTML = submitErrorText;
      setTimeout(function () {
        modalSending.classList.remove('open');
        document.body.classList.remove("no-scroll");
        form.reset();
        submitter.innerHTML = submitCurrentText;
      }, 1000)
    }
  });

  form.addEventListener('change', () => {
    updateValues(elements, watchedState);
    render(elements, watchedState);
  });

  // FIRST START
  updateValues(elements, watchedState);
  render(elements, watchedState);

  // Restart webflow scripts
  webflowRestart();
};

init();
